import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-197bd918"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "rail-container"
};
const _hoisted_2 = {
  class: "idff-content bulk-wrap"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "dis-space-3 me-top-lg"
}, "铁路站台管理困境", -1));
const _hoisted_4 = {
  class: "me-top-lg"
};
const _hoisted_5 = {
  class: "me-content-lg"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "sys-info bulk-wrap"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "数字化铁路站台", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info dis-space-1"
}, " 为铁路集运站整车运输，散货装运，采购备货，站内短倒，装卸货管理等全流程业务设计研发了完备的站内外作业及线上结算支付功能，提供pc端及手机多端协作产品，实现站台业务场景数字化。 ", -1));
const _hoisted_10 = {
  class: "sys-imgPanel"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "sys-info bulk-wrap"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "铁路站台场景业务详解图", -1));
const _hoisted_14 = {
  class: "pa-top-t"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "sys-info bulk-wrap"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "软件界面", -1));
const _hoisted_18 = {
  class: "me-top"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "advance-wrap bulk-wrap"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " 核心优势 ", -1));
const _hoisted_22 = {
  class: "advance-card me-top"
};
const _hoisted_23 = {
  class: "left"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  class: "right"
};
const _hoisted_26 = {
  class: "me-content-lg"
};
const _hoisted_27 = {
  class: "me-content-lt"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["whirt-bg-wrap", {
      entry: _ctx.idffContent.showTime
    }]),
    id: "idff-content",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("section", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.railCardList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "idd-card",
      key: index
    }, [_createElementVNode("label", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("span", null, _toDisplayString(item.content), 1), _createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_6)]);
  }), 128))])])], 6), _createElementVNode("div", {
    class: _normalizeClass(["pa-wrap default-animation-wrap", {
      entry: _ctx.platformContent.showTime
    }]),
    id: "platform-content"
  }, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    src: _ctx.sysImg1
  }, null, 8, _hoisted_11)])])], 2), _createElementVNode("div", {
    class: _normalizeClass(["whirt-bg-wrap pa-wrap default-animation-wrap", {
      entry: _ctx.chartContent.showTime
    }]),
    id: "chart-content"
  }, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
    src: _ctx.sysImg2
  }, null, 8, _hoisted_15)])])], 2), _createElementVNode("div", {
    class: _normalizeClass(["pa-wrap default-animation-wrap", {
      entry: _ctx.softwareContent.showTime
    }]),
    id: "software-content"
  }, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
    src: _ctx.sysImg3
  }, null, 8, _hoisted_19)])])], 2), _createElementVNode("div", {
    class: _normalizeClass(["whirt-bg-wrap border-b advance-content default-animation-wrap", {
      entry: _ctx.advanceContent.showTime
    }]),
    id: "advance-content",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.centerAdvanceList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "advance-item",
      key: index
    }, [_createElementVNode("div", _hoisted_23, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_24)]), _createElementVNode("div", _hoisted_25, [_createElementVNode("label", _hoisted_26, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_27, _toDisplayString(item.content), 1)])]);
  }), 128))])])], 6)]);
}